import tools from "../../tools";

export default {
    name: "Paging",
    data() {
        return {
            pageNum: "",
            rowsCount: "",
            totalRowsCount: "",
            totalPagesCount: "",
            pageList: [],
            pageText: "",
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        init: function (pageNum, rowsCount, totalRowsCount, totalPagesCount) {
            this.pageNum = pageNum;
            this.rowsCount = rowsCount;
            this.totalRowsCount = totalRowsCount;
            this.totalPagesCount = totalPagesCount;
            this.setPageNum();
        },
        //直接设置总页数
        setPageNum: function () {
            if (this.totalRowsCount == null || this.totalRowsCount == "") {
                this.setPageList(this.pageNum, this.totalPagesCount);
            } else {
                this.setPageList(this.pageNum, this.ceiling(this.totalRowsCount / this.rowsCount));
            }
        },
        /**
         * 向上取整
         */
        ceiling: function (num) {
            var floor = parseInt(num);
            if (num - floor != 0) {
                return floor + 1;
            } else {
                return floor;
            }
        },
        /**
         * 设置list
         */
        setPageList: function (count, pageTotal) {
            const _this = this;

            let listArray = new Array();
            let allPageNum = pageTotal;
            if (allPageNum == 0 || allPageNum == 1) {
                //只有一页或没有页的时候，不显示分页
                _this.pageList = [];
            } else if (allPageNum <= 5) {
                for (var i = 1; i <= allPageNum; i++) {
                    listArray.push(i.toString());
                }
            } else {
                if (count < 5) {
                    for (var i = 1; i <= 5; i++) {
                        listArray.push(i.toString());
                    }
                } else if (count > allPageNum - 5) {
                    for (var i = allPageNum - 5; i <= allPageNum; i++) {
                        listArray.push(i.toString());
                    }
                } else {
                    listArray.push((count - 2).toString());
                    listArray.push((count - 1).toString());
                    listArray.push((count).toString());
                    listArray.push((count + 1).toString());
                    listArray.push((count + 2).toString());
                }
            }

            _this.pageList = listArray;
            _this.totalPagesCount = allPageNum;
            _this.pageText = _this.pageNum;
        },
        //跳转页面
        toPage: function (page) {
            let gotoWhich = parseInt(page);
            this.PageScrollTop();
            if (gotoWhich >= 1 && gotoWhich <= this.totalPagesCount) {

            } else {
                if (gotoWhich < 1) {
                    gotoWhich = 1;
                } else if (gotoWhich > this.totalPagesCount) {
                    gotoWhich = this.totalPagesCount
                } else {
                    gotoWhich = this.pageNum;
                }
            }

            this.$emit('toPage', gotoWhich);
        },
        //分页滚动到头部
        PageScrollTop: function () {
            var weizhi = 0;
            if ($('main').length > 0) {
                weizhi = $('main').offset().top;
            }
            $('html,body').animate({scrollTop: weizhi}, 1000);
            $('main').animate({scrollTop: weizhi}, 1000);
        },
    },
};
